import {
  CalendarConfiguration,
  DEFAULT_CALENDAR_CONFIGURATION
} from './calendar-configuration.model';

import {
  ExternalProvidersConfiguration,
  DEFAULT_EXTERNAL_PROVIDERS_CONFIGURATION
} from './external-providers-configuration.model';

export interface UserConfiguration {
  // keys
  userConfigurationId: number;
  // configurations
  calendarConfiguration: CalendarConfiguration;
  externalProvidersConfiguration: ExternalProvidersConfiguration;
}

export const DEFAULT_USER_CONFIGURATION: UserConfiguration = {
  userConfigurationId: 0,
  calendarConfiguration: DEFAULT_CALENDAR_CONFIGURATION,
  externalProvidersConfiguration: DEFAULT_EXTERNAL_PROVIDERS_CONFIGURATION
};
